import React from "react";
import DateTimePickerComponent from "./dateTimePicker.component";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import { getLang } from "app/feature/constants";

function DateTimePickerContainer({
  disabled,
  id,
  value,
  handleChange,
  format,
  label,
  emptyLabel,
  disableFuture,
  error,
  helperText,
  minDate,
  maxDate,
  ...props
}) {
  const lang = useSelector(state => state.constant.languages)

  return (
    <DateTimePickerComponent
      id={id}
      value={value}
      handleChange={handleChange}
      disabled={disabled}
      format={format}
      okLabel={getLang(lang, "label.SELECT")}
      cancelLabel={getLang(lang, 'label.CANCEL')}
      label={label}
      emptyLabel={emptyLabel}
      disableFuture={disableFuture}
      error={error}
      helperText={helperText}
      minDate={minDate}
      maxDate={maxDate}
      {...props}
    />
  );
}

DateTimePickerContainer.defaultProps = {
  disabled: false,
  id: "",
  value: null,
  format: "D MMM YYYY, HH:mm",
  label: "Date",
  disableFuture: false,
  error: false,
  helperText: undefined
};

DateTimePickerContainer.propTypes = {
  id: PropTypes.string,
  disabled: PropTypes.bool,
  value: PropTypes.string,
  handleChange: PropTypes.func,
  format: PropTypes.string,
  okLabel: PropTypes.string,
  label: PropTypes.string,
  helperText: PropTypes.object,
  disableFuture: PropTypes.bool,
  error: PropTypes.bool
};

export default DateTimePickerContainer;
